import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerAddWorkerByRegistration from './ManagerAddWorkerByRegistration';
import { Size } from '../../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	onCreate: () => void;
}

const ManagerAddWorkerByRegistrationModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.workplaceAndWorkers.fillOutRegistrationForWorker'
			size={Size.LG}>
			<ManagerAddWorkerByRegistration onCreate={props.onCreate} />
		</BaseModal>
	);
};

export default ManagerAddWorkerByRegistrationModal;
